export const VNANDROIDSDK_SET_DATA_RECIEVE = 'VNANDROIDSDK_SET_DATA_RECIEVE'
export const VNANDROIDSDK_SET_VERSION = 'VNANDROIDSDK_SET_VERSION'
export const VNANDROIDSDK_IS_KEYBOARD_ACTIVE = 'VNANDROIDSDK_IS_KEYBOARD_ACTIVE'